<template>
  <div class="container">
    <img src="@/assets/images/ornament-block-pattern.svg" alt="bottom-image-ornament" class="home-ornament-bottom">
    <div class="home-content content-default">
      <div class="row align-items-center h-100">

        <div class="col-12 col-md-6 col-lg-6">
          <h1 class="title">Opps, its seems i can't find the page you're looking for.</h1>
          <p class="desc">
            <b>Error Code : 404</b>
          </p>
          
          <router-link class="btn-default w-shadow mt-30" :to="{ name: 'userHome' }">
            Back to Home Page
          </router-link>
        </div>

        <div class="col-12 col-md-6 col-lg-6 hide">
          <img src="@/assets/images/404-image.svg" alt="profile-image" class="w-100">
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  
}
</script>